const dateDiffInSeconds = (endDateString, startDateString) => {
  const endTimestamp = Date.parse(endDateString);
  const startTimestamp = Date.parse(startDateString);
  if (!Number.isNaN(endTimestamp) && !Number.isNaN(startTimestamp)) {
    return (endTimestamp - startTimestamp) / 1000;
  }
  return undefined;
};
module.exports = {
  dateDiffInSeconds
};